module.exports = __webpack_public_path__ + "static/img/ewm.13b1dc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ewm.png
// module id = PNRf
// module chunks = 32